import { Injectable } from '@angular/core'
import { Action, Selector, State, StateContext } from '@ngxs/store'
import { tap } from 'rxjs/operators'
import { TrackerStateModel } from './tracker.model'
import { TrackerService } from '../tracker.service'
import { GetTrackersData, ResetTrackers } from './tracker.actions'

@State<TrackerStateModel>({
  name: 'tracker'
})
@Injectable()
export class TrackerState {
  constructor(private trackerService: TrackerService) {}

  @Selector()
  static report(state: TrackerStateModel) {
    return state.report
  }

  @Action(ResetTrackers)
  resetTrackers(ctx: StateContext<TrackerStateModel>) {
    ctx.patchState({ report: undefined })
  }

  @Action(GetTrackersData)
  getTrackersData(ctx: StateContext<TrackerStateModel>, { payload }: GetTrackersData) {
    ctx.patchState({ report: undefined })
    return this.trackerService.getTrackerData(payload).pipe(
      tap((res) => {
        ctx.patchState({ report: res })
      })
    )
  }
}
